var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoving(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17.7 31.3c1.5-1.9 3-3.8 4.5-5.8 2-2.6 4.7-5.4 4.4-9-.2-3.3-2-6.3-4.8-8-.3-.2-.7-.4-1-.6-3.7-1.7-8.1-1-11 1.8-3 2.8-4 7.3-2.2 11 .9 1.9 2.6 3.6 3.9 5.2 1.4 1.8 2.8 3.5 4.1 5.3.4.7 1.6.7 2.1.1zm-6.6-10.5c-1.5-1.9-2-4.3-.9-6.6 1.3-2.8 4.3-4.5 7.3-4.1 3.5.4 6.2 3.6 6.2 7-.1 2.7-2.4 4.8-3.9 6.8-1 1.3-2.1 2.6-3.1 3.9-1.9-2.3-3.8-4.6-5.6-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.6 22c2.9 0 5.3-2.4 5.3-5.3s-2.4-5.3-5.3-5.3-5.3 2.4-5.3 5.3 2.4 5.3 5.3 5.3zm0-7.5c1.2 0 2.3 1 2.3 2.3s-1 2.3-2.3 2.3-2.3-1-2.3-2.3 1.1-2.3 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.4 40.4c.1-3.4-1.9-6.8-4.7-8.5 0 0-.1 0-.1-.1-.3-.2-.7-.4-1-.6-3.7-1.7-8.1-1-11 1.8-3 2.8-4 7.3-2.2 11 .9 1.9 2.6 3.6 3.9 5.2 1.4 1.8 2.8 3.5 4.1 5.3.5.6 1.7.6 2.1 0 1.5-1.9 3-3.8 4.5-5.8 1.9-2.4 4.3-5 4.4-8.3zm-6.9 6.8c-1 1.3-2.1 2.6-3.1 3.9-1.8-2.3-3.7-4.7-5.5-7-1.5-1.9-2-4.3-.9-6.6 1.3-2.8 4.3-4.5 7.3-4.1 3.5.4 6.2 3.6 6.2 7-.2 2.7-2.4 4.8-4 6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.4 34.8c-2.9 0-5.3 2.4-5.3 5.3s2.4 5.3 5.3 5.3 5.3-2.4 5.3-5.3c0-3-2.4-5.3-5.3-5.3zm0 7.5c-1.2 0-2.3-1-2.3-2.3 0-1.2 1-2.3 2.3-2.3 1.2 0 2.3 1 2.3 2.3s-1.1 2.3-2.3 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 53.9h-19.6c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1h2.6c3.9 0 7.1-3.2 7.1-7.1v-.2c0-3.9-3.2-7.1-7.1-7.1h-5.8c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h5.8c2.3 0 4.1 1.8 4.1 4.1v.2c0 2.3-1.8 4.1-4.1 4.1h-2.6c-3.9 0-7.1 3.2-7.1 7.1s3.2 7.1 7.1 7.1h19.6c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoving);
export default __webpack_public_path__ + "static/media/moving.8e5280770baf74d30cf127859dff8063.svg";
export { ForwardRef as ReactComponent };